module.exports = __webpack_public_path__ + "img/departemental.d125c034.svg";